import { BookingForm } from "../components/BookingForm";

/**
 * ClientPortal (V2.1.9 - Direct Sovereign Entry)
 * Purpose: Direct public gateway for service bookings.
 *
 * NOTE: This page now serves as a direct pass-through to the BookingForm
 * to maintain the frictionless flow required by the Sovereign protocol.
 * Redundant selection layers have been purged.
 */
export function BookingPortal() {
  return (
    <div className="min-h-[100dvh] bg-[#F8FAFC] selection:bg-slate-900 selection:text-white">
      <BookingForm />
    </div>
  );
}
